import ProjectSubscribeToNotificationsComponent from './project-subscribe-to-notifications.component'

const ProjectSubscribeToNotificationsModule = angular.module('cdbl.project-subscribe-to-notifications', [

])
  .component('cdblProjectSubscribeToNotifications', ProjectSubscribeToNotificationsComponent)
  .name

export default ProjectSubscribeToNotificationsModule
